/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';

import genericReducers from '../genericReducer';
import { IReducers } from '..';
import { ICommonResponse, IStudentEvent } from '../../api/types';
import { GET_STUDENT_EVENTS } from '../../actions';

export type StudentEventsState = ICommonResponse<IStudentEvent>;

const initialState = {
  content: [],
  loading: false,
} as ICommonResponse<IStudentEvent>;
const generic = genericReducers<StudentEventsState>();
const studentEvents: IReducers<StudentEventsState> = {
  [GET_STUDENT_EVENTS[REQUEST]]: generic.get.request,
  [GET_STUDENT_EVENTS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_EVENTS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_EVENTS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentEvents);
